import {
    GET_ITEM_SELECTOR,
    GET_CART_COUNT,
    GET_CART_LOADING,
    GET_SUBTOTAL,
    GET_SUBTOTAL_WITHOUT_DISCOUNT,
    GET_TOTAL,
    GET_SHIPMENT_PRICE,
    GET_REMAINING_FREE,
    GET_COUPON,
    GET_IS_DISCOUNT_ACTIVE_IN_CART
} from "./types";

import{GET_SHIPPING_TYPE} from '../wizard/types';
import { findDiscountByQuantity, findTotalQuantityProductsDiscountPromoted, numProductsDiscounted, validBasicRequirement } from "../../promotion/helper";
const locale = window.appLocale;

const cartGetters = {
    [GET_ITEM_SELECTOR](state) {
        return state.cartItems;
    },
    [GET_CART_COUNT](state, getters) {
        if (state.cartItems && state.cartItems.length > 0) {
            return state.cartItems
                .map(item => item.quantity)
                .reduce((total, amount) => total + amount);
        } else {
            return 0;
        }
    },
    [GET_CART_LOADING](state) {
        return state.cartLoading;
    },
    [GET_SUBTOTAL](state, getters) {
        let subtotal = getters.GET_SUBTOTAL_WITHOUT_DISCOUNT;
        if(state.coupon){
            switch(state.coupon.type){
                case 'percent':
                    subtotal -= subtotal * state.coupon.value_discount  / 100;
                    break;
                case 'fixprice':
                    subtotal -= state.coupon.value_discount;
                    break;
            }
        }
        return subtotal;
    },
    [GET_SUBTOTAL_WITHOUT_DISCOUNT](state) {
        let subtotal = 0;

        for (var item of state.cartItems) {
            let price = item.price;

            //Calculate price if product is in 'discount' promotion
            if(item.attributes.promotion && item.attributes.promotion.type === 'discount'){
                const discountPromotionProducts = findTotalQuantityProductsDiscountPromoted(state.cartItems);
                const discount = findDiscountByQuantity(item.attributes.promotion, discountPromotionProducts);
                price = (1 - (discount / 100)) * item.price
            }


            //Calculate price if product is in 'product' promotion
            const validPromotion = validBasicRequirement(item.attributes.promotion, item, item.quantity);

            if(validPromotion && validPromotion?.type === 'product' && validPromotion?.product_discount != 100){
                if(validPromotion){
                    const productsDiscounted = numProductsDiscounted(validPromotion, item.quantity);

                    subtotal += price * (item.quantity - productsDiscounted);

                    if(productsDiscounted > 0){
                        price = (1 - (validPromotion.product_discount / 100)) * item.attributes.original_price
                        for (let index = 0; index < productsDiscounted; index++) {
                            subtotal += price;
                        }
                    }
                    continue;
                }
            }
            subtotal += price * item.quantity;
        }

        return subtotal;
    },
    [GET_TOTAL](state, getters) {
        return parseFloat(getters[GET_SUBTOTAL]) + parseFloat(getters[GET_SHIPMENT_PRICE]);
    },
    [GET_SHIPMENT_PRICE](state, getters) {
        if(state.coupon?.type == 'freesend') return 0;

        return getters[GET_REMAINING_FREE] > 0 ? state.shippingType.cost : 0;
    },

    [GET_REMAINING_FREE](state, getters) {
        return parseFloat(getters[GET_SHIPPING_TYPE].free_shipping_from) - parseFloat(getters[GET_SUBTOTAL_WITHOUT_DISCOUNT]);
    },


    [GET_COUPON](state, getters) {
        return state.coupon;
    },
    [GET_IS_DISCOUNT_ACTIVE_IN_CART] (state) {
        if (state.cartItems && state.cartItems.length > 0) {
            return state.cartItems.some(item => item.attributes.original_price > item.price);
        } else {
          return false;
        }
    },
    getCouponMessage(state) {
        return state.couponmessage;
    },
    getCoupon(state) {
        return state.coupon;
    },
    getCouponApplicable(state, getters, mutations) {
        if (!getters.getCoupon) return false;

        const subtotal = getters.GET_SUBTOTAL_WITHOUT_DISCOUNT;
        const nonValidCode = {
            es: "Código no valido, tu compra debe ser de ",
            en: "Coupon not valid, your order must be of ",
            fr: "Le code n'est pas valide, votre commande doit faire ",
            de: "Dieser Code ist nicht gultig ",
        };
        const eurosOrMore = {
            es: "€ o mas.",
            en: "€ or more.",
            fr: "€ ou plus.",
            de: "€ oder mehr.",
        };
        const itemsOrMore = {
            es: " articulo o mas.",
            en: " article or more.",
            fr: " article ou plus.",
            de: " artikel oder mehr.",
        };

        switch (getters.getCoupon.requirements) {
            case "monto":
                if (subtotal >= getters.getCoupon.req_qty) {
                    state.couponmessage = "";
                    return true;
                } else {
                    state.couponmessage =
                        nonValidCode[locale] +
                        state.coupon.req_qty +
                        eurosOrMore[locale];
                    return false;
                }
            case "quantity":
                if (getters.getCartCount >= getters.getCoupon.req_qty) {
                    state.couponmessage = "";
                    return true;
                } else {
                    state.couponmessage =
                        nonValidCode[locale] +
                        state.coupon.req_qty +
                        itemsOrMore[locale];
                    return false;
                }
            case "none":
                state.couponmessage = "";
                return true;
        }
        return true;
    },
};

export default cartGetters;
